// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.redesign-section {
    padding-left: 16px;
    border-left: 3px solid #dee2e6;
    margin-bottom: 8px;
}

.compliance-section {
    padding-left: 24px;
    margin-top: 4px;
}

.reason-group {
    display: flex;
    flex-direction: column;
}

.reason-row {
    margin-bottom: 4px;
}

.compliance-test-label {
    cursor: pointer;
    font-weight: normal;
    gap: 6px;
}

mat-dialog-content {
    padding: 2px 24px !important;
    background-color: #f0f0f0;
}

.content {
    padding: 16px;
    border-radius: 4px;
    position: relative;
}

.loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.75);
    z-index: 10;
    border-radius: 4px;
}

mat-dialog-actions {
    background-color: #f0f0f0;
    padding: 8px 24px !important;
}

.button-gap {
    gap: 12px;
}

::ng-deep .mat-mdc-radio-button .mdc-form-field {
    align-items: center;
}

::ng-deep .mdc-label {
    margin-top: 7px;
}

::ng-deep .reason-radio .mdc-radio__outer-circle,
::ng-deep .reason-radio .mdc-radio__inner-circle {
    border-color: #0066B2 !important;
}

::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__outer-circle {
    border-color: #0066B2 !important;
}

::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__inner-circle {
    background-color: #0066B2 !important;
}

::ng-deep .reason-radio .mdc-radio__background::before {
    background-color: #0066B2 !important;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/duplicate-spacer-dialog/duplicate-spacer-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".redesign-section {\n    padding-left: 16px;\n    border-left: 3px solid #dee2e6;\n    margin-bottom: 8px;\n}\n\n.compliance-section {\n    padding-left: 24px;\n    margin-top: 4px;\n}\n\n.reason-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.reason-row {\n    margin-bottom: 4px;\n}\n\n.compliance-test-label {\n    cursor: pointer;\n    font-weight: normal;\n    gap: 6px;\n}\n\nmat-dialog-content {\n    padding: 2px 24px !important;\n    background-color: #f0f0f0;\n}\n\n.content {\n    padding: 16px;\n    border-radius: 4px;\n    position: relative;\n}\n\n.loading-overlay {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 255, 255, 0.75);\n    z-index: 10;\n    border-radius: 4px;\n}\n\nmat-dialog-actions {\n    background-color: #f0f0f0;\n    padding: 8px 24px !important;\n}\n\n.button-gap {\n    gap: 12px;\n}\n\n::ng-deep .mat-mdc-radio-button .mdc-form-field {\n    align-items: center;\n}\n\n::ng-deep .mdc-label {\n    margin-top: 7px;\n}\n\n::ng-deep .reason-radio .mdc-radio__outer-circle,\n::ng-deep .reason-radio .mdc-radio__inner-circle {\n    border-color: #0066B2 !important;\n}\n\n::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__outer-circle {\n    border-color: #0066B2 !important;\n}\n\n::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__inner-circle {\n    background-color: #0066B2 !important;\n}\n\n::ng-deep .reason-radio .mdc-radio__background::before {\n    background-color: #0066B2 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
